var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-area2',{attrs:{"banner":_vm.banners,"logo":"images/codesinhechos.png","clase":"codesinHechos"}}),_vm._v(" "),_c('box-container',{attrs:{"data":_vm.codesinHechos,"visible":false}}),_vm._v(" "),_c('boletin-container')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6139a9b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/codesinHechos.vue
// module id = wsEt
// module chunks = 0